module.exports = __webpack_public_path__ + "img/16581297_L.fd780481.png";